export type { Dispatch };
export { assertExhaustiveSwitch, mapDispatch };

function assertExhaustiveSwitch<A>(
	_switchedCaseValue: never,
	valueToReturn: A
): A {
	return valueToReturn;
}

interface Dispatch<Action> {
	(action: Action): Action;
}

function mapDispatch<A, B>(
	dispatch: Dispatch<B>,
	tagger: (action: A) => B
): Dispatch<A> {
	return (action: A): A => {
		dispatch(tagger(action));
		return action;
	};
}
